export const SUBMIT_BUG_REPORT = 'SUBMIT_BUG_REPORT';
export const SUBMIT_BUG_REPORT_SUCCESS = 'SUBMIT_BUG_REPORT_SUCCESS';
export const SUBMIT_BUG_REPORT_FAILURE = 'SUBMIT_BUG_REPORT_FAILURE';

export const GET_BUG_REPORTS = 'GET_BUG_REPORTS';
export const GET_BUG_REPORTS_SUCCESS = 'GET_BUG_REPORTS_SUCCESS';
export const GET_BUG_REPORTS_FAILURE = 'GET_BUG_REPORTS_FAILURE';

export const UPDATE_BUG_REPORT = 'UPDATE_BUG_REPORT';
export const UPDATE_BUG_REPORT_SUCCESS = 'UPDATE_BUG_REPORT_SUCCESS';
export const UPDATE_BUG_REPORT_FAILURE = 'UPDATE_BUG_REPORT_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/actions/bugReportsActionTypes.js